import { render } from "./ImageWithTextCell.vue?vue&type=template&id=3d16d8a0&scoped=true"
import script from "./ImageWithTextCell.vue?vue&type=script&lang=js"
export * from "./ImageWithTextCell.vue?vue&type=script&lang=js"

import "./ImageWithTextCell.vue?vue&type=style&index=0&id=3d16d8a0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d16d8a0"]])

export default __exports__